class sidebarFiltersForm extends HTMLElement {
  constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
          this.onSubmitHandler(event);
      }, 500);
      
      if(this.querySelector('form')){
          this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
      }
      const sidebarWrapper = this.querySelector('#sidebarWrapperDesktop');
      if (sidebarWrapper) sidebarWrapper.addEventListener('keyup', onKeyUpEscape);
    changeColorimage();
  }

  static setListeners() {
      const onHistoryChange = (event) => {
          const searchParams = event.state ? event.state.searchParams : sidebarFiltersForm.searchParamsInitial;
          if (searchParams === sidebarFiltersForm.searchParamsPrev) return;
          sidebarFiltersForm.renderPage(searchParams, null, false);
      }
      window.addEventListener('popstate', onHistoryChange);
    changeColorimage();
  }

  static toggleActivesidebar(disable = true) {
      document.querySelectorAll('.js-sidebar-remove').forEach((element) => {
          element.classList.toggle('disabled', disable);
      });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
      sidebarFiltersForm.searchParamsPrev = searchParams;
      const sections = sidebarFiltersForm.getSections();
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainerDesktop) {
          countContainerDesktop.classList.add('loading');
      }

      sections.forEach((section) => {
          const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
          const filterDataUrl = element => element.url === url;

          sidebarFiltersForm.filterData.some(filterDataUrl) ?
              sidebarFiltersForm.renderSectionFromCache(filterDataUrl, event) :
              sidebarFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) sidebarFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
      fetch(url)
          .then(response => response.text())
          .then((responseText) => {
              const html = responseText;
              sidebarFiltersForm.filterData = [...sidebarFiltersForm.filterData, { html, url }];
              sidebarFiltersForm.renderFilters(html, event);
              sidebarFiltersForm.renderProductGridContainer(html);
              sidebarFiltersForm.renderProductCount(html);
            changeColorimage();
          });
  }

  static renderSectionFromCache(filterDataUrl, event) {
      const html = sidebarFiltersForm.filterData.find(filterDataUrl).html;
      sidebarFiltersForm.renderFilters(html, event);
      sidebarFiltersForm.renderProductGridContainer(html);
      sidebarFiltersForm.renderProductCount(html);
    changeColorimage();
  }

  static renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    changeColorimage();
  }

  static renderProductCount(html) {
      const containerDesktop = document.getElementById('ProductCountDesktop');
      if (containerDesktop) {
          containerDesktop.classList.remove('loading');
      }
    changeColorimage();
  }

  static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const sidebarDetailsElements =
          parsedHTML.querySelectorAll('#sidebarFiltersForm .js-filter, #sidebarFiltersFormMobile .js-filter');
      const matchesIndex = (element) => {
          const jsFilter = event ? event.target.closest('.js-filter') : undefined;
          return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
      }
      const sidebarToRender = Array.from(sidebarDetailsElements).filter(element => !matchesIndex(element));
      const countsToRender = Array.from(sidebarDetailsElements).find(matchesIndex);

      sidebarToRender.forEach((element) => {
          document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      });

      sidebarFiltersForm.renderActivesidebar(parsedHTML);
      sidebarFiltersForm.renderAdditionalElements(parsedHTML);
      changeColorimage();
      if (countsToRender) sidebarFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActivesidebar(html) {
      const activesidebarElementSelectors = ['.active-sidebar-mobile', '.active-sidebar-desktop'];

      activesidebarElementSelectors.forEach((selector) => {
          const activesidebarElement = html.querySelector(selector);
          if (!activesidebarElement) return;
          document.querySelector(selector).innerHTML = activesidebarElement.innerHTML;
      })
      changeColorimage();
      sidebarFiltersForm.toggleActivesidebar(false);
  }

  static renderAdditionalElements(html) {
      const mobileElementSelectors = ['.mobile-sidebar__open', '.mobile-sidebar__count', '.sorting'];

      mobileElementSelectors.forEach((selector) => {
          if (!html.querySelector(selector)) return;
          document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });
      changeColorimage();
      document.getElementById('sidebarFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
      const targetElement = target.querySelector('.sidebar__selected');
      const sourceElement = source.querySelector('.sidebar__selected');

      if (sourceElement && targetElement) {
          target.querySelector('.sidebar__selected').outerHTML = source.querySelector('.sidebar__selected').outerHTML;
      }
  }

  static updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
      return [{
          section: document.getElementById('product-grid').dataset.id,
      }]
  }

  onSubmitHandler(event) {
      event.preventDefault();
      
      // Detect if this is a sort-only change.
      // Because nested forms are invalid HTML, the browser treats all inputs
      // as belonging to the outer #sidebarFiltersForm. When the sort select
      // changes, FormData incorrectly includes price range inputs with
      // BRL-misformatted values (e.g., "1.23200" instead of "1232.00"),
      // causing the "R$0,00 - R$1,00" filter bug.
      const changedElement = event.target;
      const isSortChange = changedElement && changedElement.name === 'sort_by';
      
      if (isSortChange) {
        // For sort changes: take current URL params and only update sort_by.
        // This preserves any active filters without re-collecting form data.
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort_by', changedElement.value);
        // Remove page param to go back to page 1 when sorting
        currentParams.delete('page');
        sidebarFiltersForm.renderPage(currentParams.toString(), event);
        return;
      }
      
      // For filter changes: collect form data normally
      const formData = new FormData(event.target.closest('form'));
      const searchParams = new URLSearchParams(formData);
      
      // Strip default price values to prevent unintended filtering.
      // BRL format: money_without_currency outputs "1.232,00", and the
      // Liquid replace chain can produce values like "1.23200" instead of "1232.00".
      const priceGte = searchParams.get('filter.v.price.gte');
      const priceLte = searchParams.get('filter.v.price.lte');
      
      // Remove min price if it's 0 or empty (untouched slider)
      if (priceGte !== null && (priceGte === '0' || priceGte === '' || parseFloat(priceGte) === 0)) {
        searchParams.delete('filter.v.price.gte');
      }
      
      // Remove max price if it wasn't explicitly moved by the user.
      // Compare against the slider's max attribute (which has the correct value
      // from the second max= attribute for BRL).
      if (priceLte !== null) {
        const form = event.target.closest('form');
        const priceInputMax = form ? form.querySelector('.range_from, .mobilerange_from') : null;
        if (priceInputMax) {
          const maxAttr = priceInputMax.getAttribute('max');
          const lteNum = parseFloat(priceLte);
          const maxNum = parseFloat(maxAttr);
          // If values match OR if the lte value looks like a BRL formatting error
          // (much smaller than max, and user didn't interact with price), strip it
          if (!isNaN(lteNum) && !isNaN(maxNum) && lteNum >= maxNum) {
            searchParams.delete('filter.v.price.lte');
          }
        }
      }
      
      sidebarFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
      event.preventDefault();
      sidebarFiltersForm.toggleActivesidebar();
      const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      sidebarFiltersForm.renderPage(url);
  }
}

sidebarFiltersForm.filterData = [];
sidebarFiltersForm.searchParamsInitial = window.location.search.slice(1);
sidebarFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('sidebar-filters-form', sidebarFiltersForm);
sidebarFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input')
            .forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
    }

    onRangeChange(event) {
        // this.adjustToValidValues(event.currentTarget);
      let val1 = document.querySelector(".range_from2").value;
        document.getElementById('range_from2').innerHTML = val1;

        let val2 = document.querySelector(".range_from").value;
        document.getElementById('range_from').innerHTML = val2;

        document.querySelector('.range_from2').addEventListener('change', function() {
            let val1 = this.value;
            document.getElementById('range_from2').innerHTML = val1;
        });

        document.querySelector('.range_from').addEventListener('change', function() {
            let val2 = this.value;
            document.getElementById('range_from').innerHTML = val2;
        });

      let val3 = document.querySelector(".mobilerange_from2").value;
        document.getElementById('mobilerange_from2').innerHTML = val3;

      let val4 = document.querySelector(".mobilerange_from").value;
      document.getElementById('mobilerange_from').innerHTML = val4;

      document.querySelector('.mobilerange_from2').addEventListener('change', function() {
          let val3 = this.value;
          document.getElementById('mobilerange_from2').innerHTML = val3;
      });

      document.querySelector('.mobilerange_from').addEventListener('change', function() {
          let val4 = this.value;
          document.getElementById('mobilerange_from').innerHTML = val4;
      });
    }

}

customElements.define('price-range', PriceRange);

class sidebarRemove extends HTMLElement {
  constructor() {
      super();
      this.querySelector('a').addEventListener('click', (event) => {
          event.preventDefault();
          const form = this.closest('sidebar-filters-form') || document.querySelector('sidebar-filters-form');
          form.onActiveFilterClick(event);
      });
  }
}

customElements.define('sidebar-remove', sidebarRemove);

/* =============================================
   FILTRO CUSTOMIZADO: Unitário / Display (CX/)
   ============================================= */
(function() {
  const CX_REGEX = /cx\s*\/\s*\d+/i;

  function isDisplay(title) {
    return CX_REGEX.test(title);
  }

  function getActiveFilter() {
    var btn = document.querySelector('.caipora-tipo-btn.active');
    return btn ? btn.getAttribute('data-filter') : 'todos';
  }

  function applyTipoFilter(filterValue) {
    if (!filterValue) filterValue = getActiveFilter();
    var gridItems = document.querySelectorAll('#ProductGridContainer .grid__item');
    gridItems.forEach(function(gridItem) {
      var titleEl = gridItem.querySelector('.card__heading a');
      if (!titleEl) return;
      var title = titleEl.textContent.trim();
      var cardIsDisplay = isDisplay(title);

      if (filterValue === 'todos') {
        gridItem.style.display = '';
      } else if (filterValue === 'display') {
        gridItem.style.display = cardIsDisplay ? '' : 'none';
      } else if (filterValue === 'unitario') {
        gridItem.style.display = cardIsDisplay ? 'none' : '';
      }
    });
  }

  function handleTipoBtnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var filterValue = e.target.getAttribute('data-filter');
    document.querySelectorAll('.caipora-tipo-btn').forEach(function(b) {
      b.classList.toggle('active', b.getAttribute('data-filter') === filterValue);
    });
    applyTipoFilter(filterValue);
  }

  // Use event delegation on document for both desktop and mobile
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.caipora-tipo-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var filterValue = btn.getAttribute('data-filter');
      document.querySelectorAll('.caipora-tipo-btn').forEach(function(b) {
        b.classList.toggle('active', b.getAttribute('data-filter') === filterValue);
      });
      applyTipoFilter(filterValue);
    }
  }, true); // useCapture = true to catch before menu-drawer

  // Re-apply after AJAX filter/sort navigation
  var origRenderProductGrid = sidebarFiltersForm.renderProductGridContainer;
  sidebarFiltersForm.renderProductGridContainer = function(html) {
    origRenderProductGrid(html);
    setTimeout(function() { applyTipoFilter(); }, 50);
  };

  // Re-initialize buttons after filter re-render (keep active state)
  var origRenderFilters = sidebarFiltersForm.renderFilters;
  sidebarFiltersForm.renderFilters = function(html, event) {
    origRenderFilters(html, event);
    // Restore active state on new buttons
    var current = getActiveFilter();
    document.querySelectorAll('.caipora-tipo-btn').forEach(function(b) {
      b.classList.toggle('active', b.getAttribute('data-filter') === current);
    });
  };

  // MutationObserver: re-apply filter when Ajaxinate loads more products
  function observeGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var observer = new MutationObserver(function(mutations) {
      var hasNewItems = mutations.some(function(m) { return m.addedNodes.length > 0; });
      if (hasNewItems) {
        if (getActiveFilter() !== 'todos') {
          setTimeout(function() { applyTipoFilter(); }, 100);
        }
        setTimeout(reorderSoldOut, 150);
      }
    });
    observer.observe(grid, { childList: true });
  }

  // ========================
  // ESTOQUE: Mover esgotados para o final do grid
  // ========================
  function reorderSoldOut() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var items = Array.from(grid.querySelectorAll('.grid__item'));
    var soldOut = [];
    var inStock = [];
    items.forEach(function(item) {
      var card = item.querySelector('.card--sold-out');
      if (card) {
        soldOut.push(item);
      } else {
        inStock.push(item);
      }
    });
    // Só reordena se há esgotados e eles não estão todos no final
    if (soldOut.length === 0) return;
    var needsReorder = false;
    var lastInStockIdx = -1;
    items.forEach(function(item, idx) {
      if (!item.querySelector('.card--sold-out')) lastInStockIdx = idx;
    });
    soldOut.forEach(function(item) {
      var idx = items.indexOf(item);
      if (idx < lastInStockIdx) needsReorder = true;
    });
    if (!needsReorder) return;
    // Move esgotados pro final
    soldOut.forEach(function(item) {
      grid.appendChild(item);
    });
  }

  // Rodar reordenação no load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observeGrid();
      reorderSoldOut();
    });
  } else {
    observeGrid();
    reorderSoldOut();
  }

  // Re-rodar após AJAX (filter/sort)
  var origRenderForReorder = sidebarFiltersForm.renderProductGridContainer;
  sidebarFiltersForm.renderProductGridContainer = function(html) {
    origRenderForReorder(html);
    setTimeout(reorderSoldOut, 200);
  };
})();